import axios from "axios";
import { useState } from "react";
import { CiCircleQuestion } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useModal } from "../../Hooks/modalContext";

const SymbolForm = () => {
  const [symbolInfo, setSymbolInfo] = useState({
    symbol_name: "",
    symbol: "",
    symbol_code: "",
  });

  const {closeModal} = useModal();

  const navigate = useNavigate(); 

  const handleUpdate = (e) => {
    const { name, value } = e.target;

    setSymbolInfo((prev) => ({
      ...prev,
      [name]: value,
    }));


  };

  const cleanSymbolCode = (code) => {
    return code.replace(/^(U\+|0x)/, ""); // Remove "U+" or "0x", keep the rest
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = {
        symbol_name: symbolInfo.symbol_name.trim(),
        symbol: symbolInfo.symbol.trim(),
        symbol_code: cleanSymbolCode(symbolInfo.symbol_code), 
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      };


      
      

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URI}/elixir/symbols`,
        JSON.stringify(data),
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

     
      

      if (res.status === 200) {
        window.alert(res.data.message);
      }

      setSymbolInfo({
        symbol_name: "",
        symbol: "",
        symbol_code: "",
      });

      closeModal();

    } catch (error) {
      if (error.response) {
        // Server responded with a status outside 2xx
        const { status, data } = error.response;
        let errorMessage = "An error occurred.";

        switch (status) {
          case 400:
            errorMessage = data.detail || "Invalid input. Please check your data.";
            break;
          case 401:
            errorMessage = "Unauthorized. Please log in again.";
            break;
          case 403:
            errorMessage = "Forbidden. You don’t have permission for this action.";
            break;
          case 404:
            errorMessage = "API endpoint not found.";
            break;
          case 500:
            errorMessage = "Internal server error. Please try again later.";
            break;
          default:
            errorMessage = data.detail || "Something went wrong.";
        }

        toast.error(errorMessage);
      } else if (error.request) {
        // Request was made, but no response received
        toast.error("Network error. Please check your internet connection.");
      } else {
        // Something went wrong setting up the request
        toast.error("Unexpected error. Please try again.");
      }

      console.error("Error submitting form:", error);
    }
  };

  return (
    <div className="flex justify-center p-4">
      <div className="flex flex-col p-6 sm:p-10 rounded-lg bg-slate-700 w-full max-w-lg">
        <h1 className="text-2xl sm:text-3xl text-white">Add Symbols</h1>

        <form onSubmit={handleSubmit} className="mt-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
            {/* Symbol Name */}
            <label className="text-white">Symbol name</label>
            <input
              type="text"
              name="symbol_name"
              value={symbolInfo.symbol_name}
              placeholder="Symbol Name"
              className="bg-gray-500 rounded text-white p-2 border w-full"
              onChange={handleUpdate}
              required
            />

            {/* Symbol */}
            <label className="text-white">Symbol</label>
            <input
              type="text"
              name="symbol"
              value={symbolInfo.symbol}
              placeholder="Add Symbol"
              onChange={handleUpdate}
              className="bg-gray-500 rounded p-2 border w-full"
              required
            />

            {/* Symbol Code */}
            <div className="flex items-center gap-2 relative">
              <label className="text-white">Symbol code</label>
              <span className="cursor-pointer group">
                <CiCircleQuestion className="text-white" />
                <div className="hidden absolute left-0 top-6 w-56 bg-slate-600 text-xs text-white rounded-lg p-2 shadow-lg group-hover:block z-50">
                  <p>
                    Select the desired UTF-16 encoding from the reference link, excluding "U+" (e.g., use "00A9" instead of "U+00A9").
                  </p>
                  <a
                    href="https://www.compart.com/en/unicode/category/So"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-400 hover:text-blue-500 underline block mt-1"
                  >
                    Reference Link
                  </a>
                  <table className="w-full border-collapse border border-gray-400 mt-2">
                    <thead>
                      <tr>
                        <th className="border border-gray-300 p-1">Symbol</th>
                        <th className="border border-gray-300 p-1">Unicode</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-gray-300 p-1">©</td>
                        <td className="border border-gray-300 p-1">00A9</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </span>
            </div>
            <input
              type="text"
              name="symbol_code"
              value={symbolInfo.symbol_code}
              placeholder="Symbol Code"
              onChange={handleUpdate}
              className="bg-gray-500 rounded p-2 border w-full"
              maxLength={8}
              required
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="p-2 w-full bg-green-500 hover:bg-green-600 rounded-sm mt-4 text-white"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default SymbolForm;